"use strict";
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.arraysMatch = exports.trimPunctuation = exports.uniqueID = void 0;
/*
 * Utility functions used in Jellyfish components
 */
/** A random string of lower-case letters and digits, e.g. "14lxwjkjz5" or "haqklj40av9".
 * Since it may start with a number, use an alphabetic prefix if using it as a JS or HTML ID. */
const uniqueID = () => Math.random().toString(36).substring(2);
exports.uniqueID = uniqueID;
/**
 * Remove non-word characters from both ends of a string, allowing parentheses and some unit symbols
 * @param input string to process
 */
const trimPunctuation = (input) => {
    var _a, _b;
    const trimmer = /^[^-\w(]*((?=[-\w(]).*[\w).…°℃℉µΩ′″%]+)[^\w).…°℃℉µΩ′″%]*$/;
    return (_b = (_a = trimmer.exec(input)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : "";
};
exports.trimPunctuation = trimPunctuation;
/**
 * Check whether arrays a and b are the same, comparing each member for equality in order.
 */
const arraysMatch = (a, b) => (!a && !b) ||
    (!!a && !!b && a.length === b.length && a.every((v, i) => v === b[i]));
exports.arraysMatch = arraysMatch;
//# sourceMappingURL=util.js.map